import { styled } from '@mui/material/styles';
import { Notification } from 'react-admin';

export const NotificationStyled = styled(Notification)(({ theme }) => ({
  '& .MuiSnackbarContent-root': {
    width: '400px',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: `
      0px 1px 18px 0px #0000001F,
      0px 6px 10px 0px #00000024,
      0px 3px 5px -1px #00000033
    `,
    padding: '20px 16px',
    fontSize: '14px',
  },
  '& .MuiSnackbarContent-message': {
    padding: 0,
  },
  '& .MuiSnackbarContent-action': {
    padding: 0,
    marginRight: 0,
  },
}));
